import {
  EnvironmentOutlined,
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  StarFilled,
  UserOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { images } from "../assets";
import CartItem from "../components/items/CartItem";
import { v4 } from "uuid";
import APIService from "../services/APIService";
import { Divider, Form, Input, notification, Radio, Select, Space } from "antd";
import { store } from "../app/store";
import {
  fetchCart,
  saveDrugStore,
  selectCart,
  selectCartWithStore,
  selectDrugStore,
  selectPaymenMethodWithStore,
} from "../app/features/cart";
import { useSelector, useDispatch } from "react-redux";
import AgencyItem from "../components/items/AgencyItem";
import { priceFormat } from "../utils";
import { useNavigate } from "react-router-dom";

const { Option } = Select;
const { TextArea } = Input;

export default function CartPage() {
  const navigate = useNavigate();
  const stateStore = store.getState();
  const cart = selectCart(stateStore);
  const drugs = useSelector(selectCartWithStore);
  const paymentMethod = useSelector(selectPaymenMethodWithStore);
  const drugStore = useSelector(selectDrugStore);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [wards, setWards] = useState([]);
  const [citySelect, setCitiSelect] = useState(null);
  const [districtSelect, setDistrictSelect] = useState(null);
  const [wardSelect, setWardSelect] = useState(null);
  const [infoPayment, setInfoPayment] = useState([]);
  const [chooseMenthod, setChooseMenthod] = useState();
  const [cartDefault, setCartDefault] = useState({});
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  async function getProvince() {
    const RESULT = await APIService.getProvince();
    if (RESULT) {
      setProvince(RESULT);
      console.log(RESULT);
    }
  }
  useEffect(() => {
    getProvince();
    getDeliveryDefault();
    store.dispatch(fetchCart);
  }, []);

  async function getDistrict(id) {
    const RESULT = await APIService.getDistrict(id);
    if (RESULT) {
      console.log(RESULT);
      setDistrict(RESULT);
      setDistrictSelect(0);
    }
  }

  useEffect(() => {
    if (cart && cart.length == 0) {
      // notification["info"]({
      //   message: "Không còn sản phẩm nào trong giỏ hàng!",
      //   description: "Quay lại trang chủ để đặt đơn hàng mới",
      // });
      navigate("/");
    } else if (cart && cart.length) {
      setChooseMenthod(paymentMethod[0]?.code);
    }
  }, [cart]);

  useEffect(() => {
    if (citySelect) {
      getDistrict(citySelect);
    }
  }, [citySelect]);

  async function getWards(id) {
    const RESULT = await APIService.getWards(id);
    if (RESULT) {
      console.log(RESULT);
      setWards(RESULT);
    }
  }

  useEffect(() => {
    getPayment();
  }, [drugStore, cart]);

  async function getPayment() {
    const RESULT = await APIService.getPayment(drugStore);
    if (RESULT) {
      setInfoPayment(RESULT);
    }
  }
  async function getDeliveryDefault() {
    const RESULT = await APIService.getDeliveryDefault();
    if (RESULT) {
      form.setFieldsValue({
        name: RESULT.name,
        address: RESULT.address,
        email: RESULT.email,
        phone: RESULT.phone,
        log: RESULT.log,
        lat: RESULT.lat,
        city_id: RESULT.city_id,
        district_id: RESULT.district_id == 0 ? null : RESULT.district_id,
        ward_id: RESULT.ward_id == 0 ? null : RESULT.ward_id,
      });
      console.log(RESULT);
      setCitiSelect(RESULT.city_id);
      setDistrictSelect(RESULT.district_id);
      setWardSelect(RESULT.ward_id);
    }
  }

  async function confirmOrder(drug_store_id, paymen_method, drug_address_info) {
    const RESULT = await APIService.confirmOrder(
      drug_store_id,
      paymen_method,
      drug_address_info
    );
    if (RESULT) {
      store.dispatch(fetchCart);
      notification["success"]({
        message: "Đặt đơn hàng thành công!",
        description: "Đơn hàng đã được lưu vào hệ thống",
      });
    }
  }

  useEffect(() => {
    if (districtSelect) {
      getWards(districtSelect);
    }
  }, [districtSelect]);

  const onFinish = (value) => {
    console.log(value);
    confirmOrder(drugStore, chooseMenthod, value);
  };

  const RenderInfoConfirm = () => {
    return (
      <>
        <div className="flex sm:flex-row flex-col gap-x-[26px] gap-y-[10px] sm:items-center mb-[21px]">
          <p className="sm:text-base sm:font-normal font-bold text-[#222222]">
            Mã Voucher
          </p>
          <div className="flex flex-row gap-x-[15px] flex-1">
            <div className="h-[46px] flex-1 flex  border-[1px] border-[#B8B8B8] border-solid">
              <input
                type="text"
                className="pl-[14px] font-semibold text-sm text-[#222222] not-italic w-full"
              />
            </div>
            <button className="px-4 h-[46px] bg-[#B8B8B8] rounded">
              <span className=" font-extrabold text-[#FFFFFF] not-italic capitalize ">
                ÁP DỤNG
              </span>
            </button>
          </div>
        </div>
        <div className=" h-[1px] bg-[#E1E1E1] mb-[15px]"></div>
        <div className="flex justify-between mb-[24px]">
          <p className="font-normal sm:text-base text-[#222222] not-italic">
            Tạm tính
          </p>
          <p className="font-bold sm:text-lg text-base text-[#2297D4] not-italic">
            {priceFormat(infoPayment.totalPayment?.tempTotal)}
          </p>
        </div>
        <div className="flex justify-between mb-[24px]">
          <p className="font-normal sm:text-base text-[#222222] not-italic">
            Phí vận chuyển
          </p>
          {infoPayment.totalPayment?.delivery_fee > 0 ? (
            <p className="font-medium sm:text-base text-sm text-[#2297D4] not-italic">
              {infoPayment.totalPayment?.delivery_fee}
            </p>
          ) : (
            <p className="font-medium sm:text-base text-sm capitalize italic text-[#6011E2]">
              Miễn Phí
            </p>
          )}
        </div>
        <div className=" h-[1px] bg-[#E1E1E1] mb-[24px]"></div>
        <div className="flex justify-between mb-[24px]">
          <h3 className="sm:text-base text-sm	 font-bold text-[#222222] not-italic capitalize mb-[3px]">
            Tổng cộng
          </h3>
          <p className="font-bold sm:text-2xl text-lg	text-[#08AF37] not-italic">
            {priceFormat(infoPayment.totalPayment?.total)}
          </p>
        </div>
        <button
          className="w-full  py-3 bg-[#2297D4] rounded"
          onClick={() => {
            form.submit();
          }}
        >
          <span className="sm:text-base font-extrabold text-[#FFFFFF] not-italic capitalize ">
            ĐẶT HÀNG
          </span>
        </button>
      </>
    );
  };

  return (
    <>
      <div className="flex flex-row overflow-scroll">
        {cart?.map((item) => (
          <button
            onClick={(e) => {
              e.stopPropagation();
              dispatch(saveDrugStore(item.id));
            }}
          >
            <div className="sm:w-[400px] w-[200px] mr-2.5">
              <AgencyItem data={item} active={item.id == drugStore} />
            </div>
          </button>
        ))}
      </div>
      <div className="h-4"></div>

      <div className="flex flex-col-reverse flex-1 w-full sm:flex-row">
        <div className="block md:hidden">
          <RenderInfoConfirm />
        </div>

        <div className="flex flex-1 flex-col sm:shadow-lg sm:bg-white rounded-[10px]">
          <div className="flex flex-col gap-y-[12px] sm:p-5">
            <h3 className="sm:text-lg not-italic font-extrabold capitalize sm:mb-[20px] mb-[5px]">
              THÔNG TIN NHẬN HÀNG
            </h3>
            <Form
              size="large"
              name="normal_login"
              className="login-form"
              onFinish={onFinish}
              form={form}
            >
              <Form.Item
                name="address"
                // rules={[{ required: true, message: "Vui lòng nhập Địa chỉ" }]}
              >
                <Input
                  prefix={
                    <EnvironmentOutlined className="mr-2 site-form-item-icon" />
                  }
                  placeholder="Địa chỉ"
                  className="text-sm font-medium cart-page placeholder:italic"
                />
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: false,
                    message: "Email không đúng định dạng",
                    type: "email",
                    pattern: RegExp(
                      /^[a-z][a-z0-9_.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/gm
                    ),
                  },
                ]}
              >
                <Input
                  prefix={<MailOutlined className="mr-2 site-form-item-icon" />}
                  placeholder="Email"
                />
              </Form.Item>
              <Form.Item
                name="name"
                rules={[{ required: false, message: "Vui lòng nhập Họ tên" }]}
              >
                <Input
                  prefix={<UserOutlined className="mr-2 site-form-item-icon" />}
                  placeholder="Họ và tên"
                  className="cart-page"
                />
              </Form.Item>
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: false,
                    message: "Vui lòng nhập Số điện thoại đúng định dạng",
                    pattern: new RegExp(/(84|0[3|5|7|8|9])+([0-9]{8,11})\b/g),
                  },
                ]}
              >
                <Input
                  prefix={
                    <PhoneOutlined className="mr-2 site-form-item-icon" />
                  }
                  placeholder="Số điện thoại"
                />
              </Form.Item>
              <div className="grid grid-cols-3 gap-4">
                <Form.Item
                  name="city_id"
                  rules={[{ required: false, message: "Chọn tỉnh thành" }]}
                >
                  <Select
                    showSearch
                    placeholder="Tỉnh Thành"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                      form.setFieldsValue({
                        city_id: value,
                        district_id: null,
                        ward_id: null,
                      });
                      setCitiSelect(value);
                    }}
                    className="font-semibold text-sm text-[#222222] select-input not-italic w-full outline-none placeholder:italic"
                  >
                    {province.map((item) => (
                      <Option value={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="district_id"
                  rules={[{ required: false, message: "Chọn quận huyện" }]}
                >
                  <Select
                    showSearch
                    placeholder="Quận Huyện"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                      form.setFieldsValue({
                        district_id: value,
                        ward_id: null,
                      });
                      setDistrictSelect(value);
                    }}
                    className="font-semibold text-sm text-[#222222] select-input not-italic w-full outline-none"
                  >
                    {district.map((item) => (
                      <Option value={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="ward_id"
                  rules={[{ required: false, message: "Chọn huyện" }]}
                >
                  <Select
                    showSearch
                    placeholder="Huyện Xã"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className="h-full font-semibold
                text-sm text-[#222222] not-italic w-full outline-none select-input"
                  >
                    {wards.map((item) => (
                      <Option value={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <Form.Item name="note_delivery">
                <Input.TextArea
                  placeholder="Ghi chú"
                  className="placeholder:italic"
                />
              </Form.Item>
            </Form>
          </div>
          <div className="gap-y-4 flex flex-col sm:px-5 pb-[35px]">
            <h3 className="sm:text-lg not-italic font-extrabold capitalize mb-[10px]">
              VẬN CHUYỂN
            </h3>
            <Radio.Group
              value={chooseMenthod}
              buttonStyle="outline"
              onChange={(value) => {
                setChooseMenthod(value.target.value);
              }}
            >
              <Space direction="vertical" className="flex flex-1 sm:mt-4">
                {paymentMethod?.map((item, index) => (
                  <>
                    <div className="flex justify-between">
                      <div className="flex">
                        <div className="flex gap-x-[45px]">
                          <div className="w-[24px] h-[24px]">
                            <img src={item.icon} alt="" />
                          </div>
                          <span className="font-semibold sm:text-base text-sm	 text-[#222222]">
                            {item.name}
                          </span>
                        </div>
                      </div>
                      <Radio value={item.code}></Radio>
                    </div>
                    {index != paymentMethod.length - 1 && (
                      <div className="w-full h-[1px] bg-gray my-2"></div>
                    )}
                  </>
                ))}
              </Space>
            </Radio.Group>
          </div>
        </div>
        <div className="w-4"></div>
        <div className="sm:shadow-lg	 sm:p-5 sm:bg-white flex flex-col flex-1.3 rounded-[10px]">
          <div className="flex items-center justify-between sm:justify-start  sm:mb-[25px] mb-[10px]">
            <h3 className="mr-3 not-italic font-extrabold capitalize sm:text-lg">
              ĐƠN HÀNG
            </h3>
            <span className="font-normal text-[#6011E2] sm:text-sm text-sm not-italic">
              {drugs.length} sản phẩm
            </span>
          </div>
          <div className="h-[1px] bg-[#E1E1E1]"></div>
          <div className="flex grid flex-1 gap-4 py-4">
            {drugs?.map((item, index) => (
              <CartItem data={item} key={index} action></CartItem>
            ))}
          </div>

          <div className=" h-[1px] bg-[#E1E1E1] mb-[30px]"></div>
          <div className="hidden w-full sm:block">
            <RenderInfoConfirm />
          </div>
        </div>
      </div>
    </>
  );
}
